export interface SolicitacaoCompra {
  CC1FILIAL: string;
  CC1NUM: string;
  CC1FORNECE: string;
  CC1LOJA: string;
  CC1SOLICIT: string;
  CC1USER: string;
  DC1EMISSAO: Date | undefined;

  items : Array<SolicitacaoCompraItem>;
}
export interface SolicitacaoCompraItem {
  CC1ITEM: string;
  CC1PRODUTO: string;
  CB1DESC: string;
  CC1DESCRI: string;
  CC1OBS: string;
  CC1UM: string;
  CC1SEGUM: string;
  CC1LOCAL: string;
  CC1RESIDUO: string;
  CC1CC: string;
  CC1CONTA: string;
  CCTTDESC01: string;
  CCTTXCLASC: string;
  CB1XCTACUS: string;
  CB1XCTADEC: string;
  CB1XCTADEA: string;
  CB1XCTADEF: string;
  CB1CONTA: string;
  CSITUACAO: string;
  NC1QUANT: number;
  NC1QUJE: number;
  NC1QTSEGUM: number;
  DC1DATPRF: Date | undefined;
}

export const defaultSolicitacaoCompra = (): SolicitacaoCompra => {
  return{
    CC1FILIAL: '',
    CC1NUM: '',
    CC1FORNECE: '',
    CC1LOJA: '',
    CC1SOLICIT: '',
    CC1USER: '',
    DC1EMISSAO: new Date(),
    items: [],
  };
};

export const defaultSolicitacaoCompraItem = (): SolicitacaoCompraItem => {
  return{
    CC1ITEM: '',
    CC1PRODUTO: '',
    CB1DESC: '',
    CC1DESCRI: '',
    CC1OBS: '',
    CC1UM: '',
    CC1SEGUM: '',
    CC1LOCAL: '',
    CC1RESIDUO: '',
    CC1CC: '',
    CC1CONTA: '',
    CCTTDESC01: '',
    CCTTXCLASC: '',
    CB1XCTACUS: '',
    CB1XCTADEC: '',
    CB1XCTADEA: '',
    CB1XCTADEF: '',
    CB1CONTA: '',
    CSITUACAO: '',
    NC1QUANT: 0,
    NC1QUJE: 0,
    NC1QTSEGUM: 0,
    DC1DATPRF: undefined,
  }
}

export interface SolicitacaoCompraLista {
  items: Array<SolicitacaoCompraListaItem>;
  hasNext: boolean;
}

export interface SolicitacaoCompraListaItem {
  CC1FILIAL: string;
  CC1NUM: string;
  CC1FORNECE: string;
  CC1LOJA: string;
  CC1SOLICIT: string;
  CC1USER: string;
  DC1EMISSAO: Date;
  CA2NOME: string;

  items: Array<SolicitacaoCompraItem>
}


export interface SolicitacaoCompraAprovar {
  items: Array<SolicitacaoCompraAprovarItem>;
  hasNext: boolean;
}

export interface SolicitacaoCompraAprovarItem {
  CC1FILIAL: string;
  CC1NUM: string;
  CC1FORNECE: string;
  CC1LOJA: string;
  CC1SOLICIT: string;
  CC1USER: string;
  DC1EMISSAO: Date;
  CC1ITEM: string;
  CC1PRODUTO: string;
  CB1DESC: string;
  CC1DESCRI: string;
  CC1OBS: string;
  CC1UM: string;
  CC1CC: string;
  CC1CONTA: string;
  CCTTDESC01: number;
  NC1QUANT: number;
  DC1DATPRF: Date;
  CA2NOME: string;
  CDECISAO: string;
  $selected: boolean;
}

export const defaultSolicitacaoCompraAprovar = (): SolicitacaoCompraAprovar => {
  return{
    items: [],
    hasNext: false,
  };
};

export interface SolicitacaoCompraPendente {
  items: Array<SolicitacaoCompraPendenteSolicitacao>;
  hasNext: boolean;
}

export interface SolicitacaoCompraPendenteSolicitacao {
  CC1FILIAL: string;
  CC1NUM: string;
  CC1FORNECE: string;
  CC1LOJA: string;
  CC1SOLICIT: string;
  CC1USER: string;
  DC1EMISSAO: Date;
  CA2NOME: string;
  items: Array<SolicitacaoCompraPendenteSolicitacaoItem>
  $selected: boolean;
}export interface SolicitacaoCompraPendenteSolicitacaoItem {
  CC1ITEM: string;
  CC1PRODUTO: string;
  CB1DESC: string;
  CC1DESCRI: string;
  CC1OBS: string;
  CC1UM: string;
  CC1CC: string;
  CC1LOCAL: string;
  CC1CONTA: string;
  CCTTDESC01: number;
  NC1QUANT: number;
  NC1QUJE: number;
  DC1DATPRF: Date;
  $selected: boolean;
}

export const defaultSolicitacaoCompraPendente = (): SolicitacaoCompraPendente => {
  return{
    items: [],
    hasNext: false,
  };
};
